export default "__VITE_ASSET__yGHqyTdy__"